export interface CheckRecordExistenceRequest {
  business_name?: string;
  email?: string;
}

export enum RecordSourceType {
  CRF = 2,
  CRM_DNB = 3,
  CUSTOM = 4,
  DATA_AXLE = 5,
  PUBLIC = 6,
  SME = 7,
  VLF = 8,
}

export interface RecordMatch {
  id: number;
  unique_id: string;
  business_name: string;
  email: string | null;
  phone: string | null;
  city: string;
  state: string;
  source_type: number;
  visibility_mode: number;
  created_on_utc: string;
  match_reasons: string[];
}
